import {Elements} from '@stripe/react-stripe-js';
import { getPaymentIntent } from '../../../services/api';
import Modal from "react-modal";
import React, { useState } from "react";
import { useEffect,useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Retakecheckout from "../Retakecheckout";
import { CourseContext } from "../CourseContext";
import { getStripePromise } from '../../../utils/stripe';

const Aside = (props) => {
  const {
    sections,
    setPages,
    setTopic,
    setCurrentSection,
    topic,
    setQuizalert,
    showSuccess,
    setShowSuccess,
    sidebarlock,
    startcourse,
  } = useContext(CourseContext) || {};
  // Use centralized Stripe instance
  const stripePromise = getStripePromise();
  
  const activeTopicRef = useRef(null);
  const [quizDone, setQuizDone] = useState(false);
  const navigate= useNavigate();
const [clientSecret, setClientSecret] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isloader , setIsLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingTopicId, setLoadingTopicId] = useState(null);
  const [lastClickTime, setLastClickTime] = useState(0);
  useEffect(() => {
    const quizStatus = sessionStorage.getItem('quizDone') === 'true';
    setQuizDone(quizStatus);
    
    // Cleanup function to prevent memory leaks
    return () => {
      setClientSecret("");
      setIsModalOpen(false);
    };
  }, []);

  useEffect(() => {
    let lastTopicFound = false;
  
    for (const section of (sections || props.sections)) {
      const topics = section.topics;
      
      // Count topics with status = 2 and status = 1
      const status2Count = topics.filter(topic => topic.status === "2").length;
      const status1Count = topics.filter(topic => topic.status === "1").length;
  
      // Check condition: all topics have status 2 except one with status 1
      if (status1Count === 1 && status2Count === topics.length - 1) {
        lastTopicFound = true;
        break;
      }
    }
  
    // Store the result in sessionStorage
    if (lastTopicFound) {
      sessionStorage.setItem("lastTopic", "1");
    } else {
      sessionStorage.setItem("lastTopic", "0");
    }
  }, [sections, props.sections]);
  

  useEffect(()=>{
    if (activeTopicRef.current) {
      activeTopicRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  },[props.sections])

  // Scroll to current (yellow) topic when topic changes
  useEffect(() => {
    if (activeTopicRef.current) {
      activeTopicRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [topic])

  useEffect(()=>{
    // Only automatically set current topic if course has been started
    if (!startcourse) {
      return;
    }
    
    let foundTopic = null;
    let foundSection = null;

    for (const section of (sections || props.sections)) {
      foundTopic = section.topics.find(topic => topic.status === "1");
      if (foundTopic) {
        foundSection = section;
        break; 
      }
    }
    if (foundTopic) {
      sessionStorage.setItem("currentTopic", JSON.stringify(foundTopic.topics));
      sessionStorage.setItem("currentTopicId", foundTopic.topics.id);
      sessionStorage.setItem("topicStatus", foundTopic.status);
      (setTopic || props.setTopic)?.(foundTopic.topics);
      // Don't set pages here - they'll be fetched via fetchPages API when topic changes
      (setCurrentSection || props.setCurrentSection)?.(foundSection.sections);
      if (activeTopicRef.current) {
        activeTopicRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  },[startcourse, sections, props.sections]);

  const handleNext = async (e) => {
      setIsLoading(true);
      e.preventDefault();
      
      try {
        const response = await getPaymentIntent();
        if (response && response.data) {
          setClientSecret(response.data);
          setIsModalOpen(true);
        } else {
          console.error('Failed to get payment intent');
        }
      } catch (error) {
        console.error('Error getting payment intent:', error);
      } finally {
        setIsLoading(false);
      }
  };
  const handleExam=()=>{
		sessionStorage.setItem("examAllow",true);
		navigate('/course/take-exam')
  }
  

  return (
    <>
      <aside
        className={`sidebar bg-secondary-s p-4 rounded-2 mh-100 shadow-sm overflow-x-hidden overflow-y-auto ${
          props.disableSticky ? "" : "sticky-top top-20"
        }`}
        style={props.compact ? { fontSize: "1rem" } : undefined}
      >
        <ul className="tasks">
          {(sections || props.sections)?.map((section, sectionindex) => {
            const currentTopicId = (topic && topic.id) ? String(topic.id) : String(sessionStorage.getItem("currentTopicId"));
            const isSectionOpen = section.topics.some(
              (t) => t.status === "1" || String(t.topics.id) === String(currentTopicId)
            );

            return (
              <li
                key={sectionindex}
                className={`position-relative ${
                  section.status === "2" ? "donesection" : "notDone"
                }`}
              >
                <div
                  className="accordion"
                  id={`accordionExample${section.sections.id}`}
                >
                  <div className="accordion-item bg-none border-0 rounded-2 mb-4">
                    <h2 className="accordion-header">
                      <button
                        className={`accordion-button rounded-2 shadow-none ${
                          isSectionOpen ? "custom-open" : "collapsed"
                        }`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${section.sections.id}`}
                        aria-expanded={isSectionOpen ? "true" : "false"}
                        aria-controls={`collapse${section.sections.id}`}
                      >
                        <strong className="d-block">
                          {section.sections.title}
                        </strong>
                      </button>
                    </h2>
                    <div
                      id={`collapse${section.sections.id}`}
                      className={`accordion-collapse collapse ${
                        isSectionOpen ? "show" : ""
                      } px-0`}
                      data-bs-parent={`#accordionExample${section.sections.id}`}
                    >
                      <div className="accordion-body ps-0 pe-0 pt-2 pb-0">
                        {section.topics.map((topic, topicindex) => (
                          <><button
                          key={topicindex}
                          ref={String(topic.topics.id) === String(currentTopicId) ? activeTopicRef : null}
                          className={`btn btn-primary-topic  ${
                            topic.time_spent === 0 ? "donetopic" : ""
                          } ${
                            topic.status === "1" ? "" : ""
                          } ${
                            String(topic.topics.id) === String(currentTopicId) ? "current-topic" : ""
                          } text-white w-100 text-start py-2 px-3 mt-1 last-btns fs-12`}
                            onClick={() => {
                            if(!(sidebarlock ?? props.sidebarlock)){
                              // Debounce rapid clicks to prevent Stripe conflicts
                              const now = Date.now();
                              if (now - lastClickTime < 500) {
                                return; // Ignore rapid clicks
                              }
                              setLastClickTime(now);
                              
                              setLoadingTopicId(topic.topics.id); // Show loading for this topic
                              (setQuizalert || props.setQuizalert)?.(false);
                              (setTopic || props.setTopic)?.(topic.topics);
                              sessionStorage.setItem("currentTopic",JSON.stringify(topic.topics));
                              sessionStorage.setItem("currentTopicId",topic.topics.id);
                              sessionStorage.setItem("topicStatus",topic.status);
                              sessionStorage.setItem("chapterID",topicindex+1);
                              // Don't set pages here - they'll be fetched via fetchPages API when topic changes
                              (setCurrentSection || props.setCurrentSection)?.(section.sections);
                              if (
                                sectionindex === props.sections.length - 1 
                                &&
                                topicindex === section.topics.length - 1
                              ) {
                                sessionStorage.setItem("lastTopic", "1");
                              } else {
                                sessionStorage.setItem("lastTopic", "0");
                              }
                              
                              // Clear loading state after a short delay
                              setTimeout(() => {
                                setLoadingTopicId(null);
                              }, 1000);

                              // If a mobile-specific close handler is provided (Dashboard overlay),
                              // invoke it after selecting a topic to close the chapters panel.
                              if (props.onTopicSelect) {
                                props.onTopicSelect();
                              }
                            }
                            
                          }}
                          disabled={topic.status === "0"}
                        >
                          {loadingTopicId === topic.topics.id ? (
                            <i className="fa fa-spinner fa-spin"></i>
                          ) : topic.time_spent === 0 ? (
                            <i className=" icon fa fa-check-circle "></i>
                          ) : (
                            <i className="fa fa-angle-right"></i>
                          )}
                         {" "}
                          Section {topic.topics.topic_code}: {topic.topics.title}
                         
                          <small className="fs-11 float-end mt-1">
                            ({topic.topics.pages_count || 0} Pages)
                          </small>
                        </button>
                        <span className={`mt-1 ${topic.status === "2"?'active':'notactive'  } `}>{topic.status === "2"?(<><i className="fa fa-check" aria-hidden="true"></i></>):(<></>)} Section Quiz </span>
                        </>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
        <span className="">
          {/* {JSON.parse(sessionStorage.getItem('user')).retake_status === '1'?	<button className="call-to-action-btn border-0 mt-4 py-3" onClick={handleExam} style={{background: '#044a90'}}>Exam Retake</button>:<></>}
          {JSON.parse(sessionStorage.getItem('user')).retake_status === '2' && JSON.parse(sessionStorage.getItem('user')).retake_permission === '1' ?	<button onClick={handleExam} className="call-to-action-btn border-0 mt-4 py-3" style={{background: '#044a90'}}>Exam Retake</button>:<></>} */}
          {/* {JSON.parse(sessionStorage.getItem('user')).retake_status === '2' && JSON.parse(sessionStorage.getItem('user')).retake_permission === '0' ?	<button  onClick={handleNext} className="call-to-action-btn border-0 mt-4 py-3" style={{background: '#e38d26'}}>{isLoading ? (
							<span>Loading...</span>  // Show loading text or a spinner
						) : (
							'Purchase Retake'  // Show the button text when not loading
						)}
						</button>:<></>} */}
        </span>
        <Modal
				isOpen={isModalOpen}
				onRequestClose={() => setIsModalOpen(false)}
				className="modal-class"
				overlayClassName="overlay-class"
				ariaHideApp={false}
			>
				<div className="modal-header">
				<h2>Complete Your Payment</h2>
				<button onClick={() => setIsModalOpen(false)} className="close-btn">
					&times;
				</button>
				</div>
				<div className="modal-body">
				{clientSecret && stripePromise ? (
					<Elements stripe={stripePromise} options={{ clientSecret }}> 
					<Retakecheckout
						clientSecret={clientSecret}
						setIsLoader={setIsLoader}
					/>
					</Elements>
				) : (
					<div className="text-center">
						<div className="spinner-border text-primary mb-3" role="status">
							<span className="visually-hidden">Loading...</span>
						</div>
						<p>Loading payment details...</p>
					</div>
				)}
				</div>
			</Modal>
        
      </aside>
    </>
  );
};

export default Aside;
